import queryString from "qs";
export function parseQueryParams(search: string): { [key: string]: string | undefined } {
    return queryString.parse(search.replace(/^\?/, ""));
}
